module.exports = __webpack_public_path__ + "img/epay-bottom.21c951d8.png";